import classNames from 'classnames';
import { Text, Box, Link, Grid } from '@stitch-fix/mode-react';
import { BoxDelivery } from './Icons/BoxDelivery';
import { Camera } from './Icons/Camera';
import { HangerHeart } from './Icons/HangerHeart';
import { Learning } from './Icons/Learning';
import styles from './style.module.scss';
import { Collaborative } from './Icons/Collaborative';
import { Compensation } from './Icons/Compensation';
import { Discounts } from './Icons/Discounts';
import { Vacation } from './Icons/Vacation';
import Wellness from './Icons/Wellness';

export type FlexBlurbsProps = {
  title?: string;
  blocks: {
    icon: keyof typeof icons;
    title: string;
    description: string;
  }[];
  bgColor: 'light' | 'dark';
  link?: {
    title: string;
    href: string;
  };
};

const icons = {
  'hanger-heart': <HangerHeart />,
  camera: <Camera />,
  'box-delivery': <BoxDelivery />,
  learning: <Learning />,
  collaborative: <Collaborative />,
  compensation: <Compensation />,
  discounts: <Discounts />,
  vacation: <Vacation />,
  wellness: <Wellness />,
};

export const FlexBlurbs = ({
  title,
  blocks,
  link,
  bgColor,
}: FlexBlurbsProps) => (
  <Box
    pt={3.75}
    style={{ textAlign: 'center' }}
    m="0 auto"
    maxWidth={90}
    className={classNames(styles.container, styles[bgColor])}
  >
    {title && (
      <Box m="0 0 1.25rem">
        <Text setting="title-medium">{title}</Text>
      </Box>
    )}

    <Box maxWidth="1170px" m="0 auto" p="0 0 3.75rem" className={styles.blocks}>
      <Grid columns={{ sm: 1, md: 3, lg: 3 }} spacing="none">
        {blocks.map(block => (
          <Box p="0.625rem 2.1875rem" m="0 auto" key={block.title}>
            <Box height={3.75} width={3.75} m="0 auto" className={styles.icon}>
              {icons[block.icon]}
            </Box>

            <Text mt={1} mb={0.625} setting="title-xsmall" spacingBottom>
              {block.title}
            </Text>

            <Text setting="body-small">{block.description}</Text>
          </Box>
        ))}
      </Grid>
    </Box>
    {link?.href && link?.title && (
      <Box
        p="1.875rem 0 3.125rem"
        maxWidth="680px"
        width="80%"
        m="0 auto"
        className={styles.link}
      >
        <Link
          variant={bgColor === 'dark' ? 'on-dark' : 'inherit'}
          href={link.href}
        >
          {link.title}
        </Link>
      </Box>
    )}
  </Box>
);
